import { Injectable } from '@angular/core';
import {Cart} from "../classes/cart";
import {Storage} from '@ionic/storage';
import {ToastController} from "ionic-angular";
import {StorageService} from "./storage.service";

@Injectable()
export class CartService {
  public static cart : Cart;
  constructor(public storage : StorageService, public toastCtrl : ToastController){

  }
  /**
   * Singleton class for cart since there is only one cart in the whole application
   * @returns {Cart}
   */
  getCart(){
    if (typeof CartService.cart === "undefined"){
      CartService.cart = new Cart(this.storage, this.toastCtrl);
      //this.storage.get("cart:products").then((payloads) => {
      //  CartService.cart.products = CartService.cart.deserialize(payloads);
      //});
    }
    return CartService.cart;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cart.service.ts